import React from "react";
import type Stripe from "stripe";

import Typography from "../../../components/Text";

interface CreditCardNumberProps {
	paymentMethod: Stripe.PaymentMethod;
}

const CreditCardNumber = ({ paymentMethod }: CreditCardNumberProps) => {
	const last4 = paymentMethod.card?.last4;
	if (!last4) {
		return null;
	}

	return (
		<div className="space-y-1">
			<Typography size="paragraph-1" weight="semi-bold">
				Current card number
			</Typography>
			<Typography size="paragraph-2" weight="regular" className="tracking-widest">
				•••• •••• •••• {last4}
			</Typography>
		</div>
	);
};

export default CreditCardNumber;
